/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./BaseDropdown.vue?vue&type=template&id=013730e5"
import script from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseDropdown.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BaseDropdown.vue?vue&type=style&index=0&id=013730e5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports